import { config } from '../config';

export function initConfigure (App) {
  const configDef = { get () { return config; } };
  Object.defineProperty(App, 'config', configDef);
  Object.defineProperty(App.prototype, 'config', configDef);

  App.configure = (options) => {
    Object.assign(config, options);
  };
}
